//#region ENUM StoreDisplayOrderEnum
/**
 * ### StoreDisplayOrderEnum
 * Defines the available options for ordering the display of stores in the application
 *
 * @enum {string}
 * @property ALPHABETICAL - Display stores in alphabetical order by name
 * @property CUSTOM - Display stores in custom user-defined order
 */
export enum StoreDisplayOrderEnum {
  ALPHABETICAL = 'Alphabetical',
  CUSTOM = 'Custom',
}

//#endregion
